import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const getStatusPattern = async (testSuiteResultId) => {
  const userDetails = localStorage.getItem("userDetail");

  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getStatusPatternCountsForTestSuiteResult&companyid=${user.companyid}&testSuiteResultId=${testSuiteResultId}`,
  );

  return response.data;
};

const useGetStatusPattern = (testSuiteResultId, options) => {
  return useQuery({
    queryKey: ["statusPattern", testSuiteResultId],
    queryFn: () => getStatusPattern(testSuiteResultId),
    enabled: options.enabled,
    ...options,
  });
};

export default useGetStatusPattern;
